export const AGENT_PAY_COMPONENT_HYPOTHESIS_ID = 'id';
export const AGENT_IFSE_HYPOTHESES = 'ifsePayComponentHypotheses';
export const AGENT_PONCTUAL_PRIME_HYPOTHESES =
    'ponctualPrimesPayComponentHypotheses';
